import _ from 'lodash'
import store from '../store'
import { hasPermissionStatus } from './permission'
export { default as queryAllSearchParams } from './location-query'
export * from './timestamp'
export * from './env'
export * from './array'
export * from './formatTime'
export * from './permission'
export { REFRESH_KEYS } from './refresh-manager/constants'
export * from '@rayvision/refresh-manager'
export const hasClass = (target, cls) => {
  return new RegExp(`(\\s|^)${cls}(\\s|$)`).test(target.className)
}

// 收集选择ID集
export const getIdsList = (ids) => {
  let idsList = []
  ids.forEach(item => {
    idsList.push(...item)
  })
  return idsList
}

// 多选的逻辑
// // 获取Dom的parents
export const getParents = (el, tagName) => {
  let parents = []
  let parentNoe = el.parentNode
  let parentTarget = parentNoe.tagName

  while (parentTarget !== tagName.toUpperCase()) {
    const o = parentNoe
    parents.push(o)
    parentNoe = o.parentNode
    parentTarget = parentNoe.tagName
  }
  parents.push(parentNoe) // Push that parentSelector you wanted to stop at

  return parents
}

// 剔除对象中空值的属性
export const objectTrim = (obj, ignore = false, delNull = false, delEmptyString = true, delArray = false) => {
  return _.pickBy(obj, (v, k) => {
    if (ignore) {
      if (ignore.includes(k)) return true
    }
    if (delEmptyString && v === '') {
      return false
    }
    if (delNull && v === null) {
      return false
    }
    if (delArray && v instanceof Array && v.length === 0) {
      return false
    }
    return true
  })
}

export const getHeaderName = (headers) => {
  const fileName = headers['content-disposition'].split(';')[1].split('=')[1]
  return decodeURI(fileName)
}

export const getContentType = (header, field) => {
  const value = header[field]
  if (!value) return ''
  const fileName = header[field].split(';')[0]
  return decodeURI(fileName)
}

export const digitUppercase = (n) => {
  var fraction = ['角', '分']
  var digit = [
    '零', '壹', '贰', '叁', '肆',
    '伍', '陆', '柒', '捌', '玖',
  ]
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ]
  var head = n < 0 ? '欠' : ''
  n = Math.abs(n)
  var s = ''
  for (var i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (var k = 0; k < unit[0].length && n > 0; k++) {
    var p = ''
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][k] + s
  }
  return head + s.replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
}

export const timestampToDate = (timestamp) => {
  let date = new Date(timestamp)
  let Y = date.getFullYear() + '-'
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ''
  return Y + M + D
}

// 判断是否有权限
/**
 * @param url 路由组件的url
 * @param permissionKey 路由组件的权限名
 */
export const importWithPermission = (component, permissionKey) => {
  const permission = hasPermissionStatus(store.getters['home/permissionList'], permissionKey)
  return permission === false ? import('@/views/Error/403.vue') : component
}

// 判断返回是否为json字符串
export const isJsonString = (str) => {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true
    }
  } catch (e) {
    return false
  }
}

// 浮点型数字处理
export const strip = (num, precision = 12) => {
  return +parseFloat(num.toPrecision(precision))
}

// 判断是否为空对象
export const isEmptyObject = (target) => {
  for (let key in target) {
    return false
  }
  return true
}

// 多个对象数组的并集
export const unionMultipleArrayObjects = (flag, ...arrayObjects) => {
  let result = []
  let flagList = []
  let data = []
  if (!(arrayObjects.length > 0)) return
  for (let val of Array.from(arrayObjects)) {
    data.push(...val)
  }
  data.filter((value) => {
    if (!flagList.includes(value[flag])) {
      flagList.push(value[flag])
      result.push(value)
    }
  })
  return result
}

// 以第一对象参数为原型的多个对象合并（取第一个对象的非补集）
export const objectIntersection = (sourceTarget, ...otherTarget) => {
  // intersection 返回具有两个数组交集元素组成的数组
  // pick 根据特定数组元素值获取源对象的子对象
  let result = {}
  otherTarget.forEach(v => {
    const intersection = _.intersection(_.keys(sourceTarget), _.keys(v))
    const intersectionObject = _.pick(v, intersection)
    result = {
      ...sourceTarget,
      ...intersectionObject,
    }
  })
  return result
}

// 修复router切换时自动把query的数字转成字符串
export const valueChangeNumber = (obj, excludeKey = []) => {
  let target = _.clone(obj)
  Reflect.ownKeys(target).forEach(v => {
    // eslint-disable-next-line
    if (target[v] && !excludeKey.includes(v) && Number(target[v]) == target[v]) {
      target[v] = Number(target[v])
    }
  })
  return target
}

export const valueChangeArray = (obj, keys = [], numberKeys = []) => {
  let target = _.clone(obj)
  Reflect.ownKeys(target).forEach(v => {
    // eslint-disable-next-line
    if (!keys.includes(v)) return
    const val = target[v]
    if (val === undefined || val === null || val === '') return

    let arr
    if (Array.isArray(val)) {
      arr = val
    } else if (typeof val === 'string') {
      arr = val.split(',')
    } else {
      arr = [val]
    }

    let result = arr
      .map(item => (typeof item === 'string' ? item.trim() : item))
      .filter(item => item !== '')

    if (numberKeys.includes(v)) {
      result = result
        .map(item => Number(item))
        .filter(item => !Number.isNaN(item))
    }
    target[v] = result
  })
  return target
}

// // 两位小数的金额验证
// export const moneyVerify = (e, negative = false) => {
//   let val = ''
//   !negative && (val = e.target.value.replace(/[^\d.]/g, ''))        // 限制通过数字和小数点
//   negative && (val = e.target.value.replace(/[^\d.-]/g, ''))        // 限制通过数字、小数点和负数
//   val = val.replace(/\.{2,}/g, '.')                      // 只保留第一个小数点 清除多余的
//   val = val.replace(/^0*(0\.|[1-9])/, '$1')              // 解决 粘贴不生效
//   val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
//   val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
//   if (val !== '' && val.substr(0, 1) === '.') {          // 限制小数点开头
//     val = ''
//   }
//   if (val.indexOf('.') < 0 && val !== '') {                // 如果没有小数点，首位不能为类似于 01、02的金额
//     if (val.substr(0, 1) === '0' && val.length === 2) {
//       val = val.substr(1, val.length)
//     }
//   }
//   e.target.value = val
// }

// 仅限于input的type=number 金额保留两位小数
export const moneyVerify = (e, negative = false) => {
  if (negative) {
    // e.target.value = e.target.value.replace(/^(\-)*(\d+)/g, '')
    let val = String(e.target.value).replace(/[^\d.-]/g, '')     // 限制通过数字和小数点
    val = val.replace(/\.{2,}/g, '.')                      // 只保留第一个小数点 清除多余的
    val = val.replace(/^0*(0\.|[1-9])/, '$1')              // 解决 粘贴不生效
    val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    if (val !== '' && val.substr(0, 1) === '.') {          // 限制小数点开头
      val = ''
    }
    if (val.indexOf('.') < 0 && val !== '') {                // 如果没有小数点，首位不能为类似于 01、02的金额
      if (val.substr(0, 1) === '0' && val.length === 2) {
        val = val.substr(1, val.length)
      }
    }
    e.target.value = val
    return e.target.value
  } else {
    e.target.value = e.target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  }
  return e.target.value
}

export const flatten = (arr) => {
  var res = []
  for (let i = 0, length = arr.length; i < length; i++) {
    if (Array.isArray(arr[i])) {
      res = res.concat(flatten(arr[i]))
    } else {
      res.push(arr[i])
    }
  }
  return res
}

/**
 * 模糊搜索
 * @param {*} inputValue
 * usage
 * const Reg = generReg(inputValue)
 * srcArr.filter((e) => Reg.test(e.value))
 */
export const generReg = (inputValue) => {
  return new RegExp(`(.*)(${inputValue.split('').join(')(.*)(')})(.*)`, 'i')
}
